<template>
  <div class="flex-grow overflow-y-auto bg-lightGray p-4">
    <router-view />
  </div>
</template>

<script setup lang="ts">
// Simplified: content only - SidebarMenu provides navigation
</script>
